/**
 * @file Permission 模块枚举类型定义
 * @description 定义权限管理相关的枚举类型
 * 
 * @module @bayes-mes/shared/types/permission
 * @category Types - Permission
 * 
 * @backend-files
 * - backend/app/Models/Permission.php (权限类型常量)
 * 
 * @notes
 * - 枚举值必须与后端完全一致（大小写敏感）
 * - 所有枚举必须有中文注释说明
 * - 新增枚举时同步更新 constants.ts 的标签映射
 * 
 * @update-trigger
 * - 后端新增权限类型时
 * - Model 常量定义变更时
 * 
 * @last-updated 2025-10-18
 * @author YSFL Team
 */

/**
 * 权限类型
 * @description 定义系统中的权限类型
 */
export enum PermissionType {
  /** 菜单权限 */
  MENU = 1,
  /** 按钮权限 */
  BUTTON = 2,
  /** API权限 */
  API = 3,
  /** 数据权限 */
  DATA = 4,
}

/**
 * 权限状态
 * @description 权限的启用状态
 */
export enum PermissionStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

